export const FETCH_GENERAL_EQUIPMENT_ENERGY_TOTAL_TREND_REQUEST =
  '[GeneralEquipmentEnergyTotalTrend] FETCH_GENERAL_EQUIPMENT_ENERGY_TOTAL_TREND_REQUEST';
export const FETCH_GENERAL_EQUIPMENT_ENERGY_TOTAL_TREND_SUCCESS =
  '[GeneralEquipmentEnergyTotalTrend] FETCH_GENERAL_EQUIPMENT_ENERGY_TOTAL_TREND_SUCCESS';
export const FETCH_GENERAL_EQUIPMENT_ENERGY_TOTAL_TREND_FAILURE =
  '[GeneralEquipmentEnergyTotalTrend] FETCH_GENERAL_EQUIPMENT_ENERGY_TOTAL_TREND_FAILURE';
